import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SeoUpdate } from '../../services';

export const fetchSeoUpdate = createAsyncThunk(
    'seoUpdate/fetchSeoUpdate',
    async ({ id, file, title, description, keywords, canonical, author }) => {
        const response = await SeoUpdate(id, file, title, description, keywords, canonical, author)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const seoUpdateSlice = createSlice({
    name: 'seoUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSeoUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSeoUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSeoUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default seoUpdateSlice.reducer;
